import { ViewStream } from 'spyne';
import { DeckContainerTraits } from 'traits/deck/deck-container-traits.js';

export class DeckContainer extends ViewStream {
  constructor(props = {}) {
    props.class = 'deck-container';
    props.channels = ['CHANNEL_DECK', 'CHANNEL_SLIDESHOW'];
    props.traits = [DeckContainerTraits];
    super(props);
  }

  addActionListeners() {
    return [
      ['CHANNEL_DECK_INIT_EVENT', 'deckContainer$OnDeckInit'],
      ['CHANNEL_SLIDESHOW_ACTIVATED_EVENT', 'deckContainer$OnSlideshowActivated'],
      ['CHANNEL_SLIDESHOW_DEACTIVATED_EVENT', 'deckContainer$OnSlideshowDeactivated'],
    ];
  }
}
